import { Card, styled } from '@mui/material';

const StyledCard = styled(Card)({
  // transition: 'transform .3s ease-in-out',
  boxShadow: ' 0 0 10px 4px rgba(241, 241, 241, 1)',
  borderRadius: '20px 20px 0 0',
  overflow: 'hidden',
  border: '0 !important',
});

export default StyledCard;
